import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { ITopic } from "../../models/ITopic";
import { ICreditType } from "../../models/ICreditType";
import { PageContext } from "../../service/PageContext";
import { SpecialtySelect } from "../healioGlobal/SpecialtySelect";
import { EventUtil } from "../../util/EventUtil";

export class TopicAndCreditTypeFilter extends Component {
  public static readonly TopicFilterChangeEvent: string =
    "TopicFilterChangeEvent";

  private readonly _topicMenuContainer: HTMLElement | null;
  private readonly _topicMenuTemplate: HTMLElement | null;
  private readonly _creditTypeMenuContainer: HTMLElement | null;
  private readonly _creditTypeMenuTemplate: HTMLElement | null;
  private readonly _chipsContainer: HTMLElement | null;
  private readonly _topicChipsTemplate: HTMLElement | null;
  private readonly _creditTypeChipsTemplate: HTMLElement | null;
  private readonly _clearTopicsButton: HTMLElement | null;
  private readonly _applyTopicsButton: HTMLElement | null;
  private readonly _applyCreditTypesButton: HTMLElement | null;

  private _lastSelectedValue: ReadonlyArray<string> = [];
  private _selectedTopics: ITopic[] = [];
  private _selectedCreditTypes: ICreditType[] = [];
  private _specialtyId: string = "";


  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);

    this._topicMenuContainer = this._element.querySelector("[data-initialize-as='topic menu']");
    this._topicMenuTemplate = this._element.querySelector("[data-initialize-as='topic menu template']");
    this._creditTypeMenuContainer = this._element.querySelector("[data-initialize-as='credit type menu']");
    this._creditTypeMenuTemplate = this._element.querySelector("[data-initialize-as='credit type menu template']");
    this._chipsContainer = this._element.querySelector("[data-initialize-as='topic chips']");
    this._creditTypeChipsTemplate = this._element.querySelector("[data-initialize-as='credit type chips template']");
    this._topicChipsTemplate = this._element.querySelector("[data-initialize-as='topic chips template']");
    this._clearTopicsButton = this._element.querySelector("[data-initialize-as='clear topics']");
    this._applyTopicsButton = this._element.querySelector("[data-initialize-as='apply topics']");
    this._applyCreditTypesButton = this._element.querySelector("[data-initialize-as='apply credit types']");

    document.addEventListener(SpecialtySelect.SpecialtySelectInitEvent, e => this.handleSpecialtyChange(e as CustomEvent<string>));

    if(this._applyTopicsButton){
      this._applyTopicsButton.addEventListener("click", ev => this.handleMenuApply(ev));
    }
    if(this._applyCreditTypesButton){
      this._applyCreditTypesButton.addEventListener("click", ev => this.handleMenuApply(ev));
    }

    if(this._clearTopicsButton){
      this._clearTopicsButton.addEventListener("click", ev => this.handleClearAllTopics(ev));
    }

    if(this._applyCreditTypesButton){
      this._applyCreditTypesButton.addEventListener("click", ev => this.handleMenuApply(ev));
    }

    $(this._element).find(".dropdown-menu").on("click.bs.dropdown", function (e) {
      e.stopPropagation();
    });
  }

  // public get topics(): ReadonlyArray<ITopic> {
  //   return this._selectedTopics;
  // }

  public get topics(): ReadonlyArray<ITopic> {
    return this._selectedTopics;
  }

  public get creditTypes(): ReadonlyArray<ICreditType> {
    return this._selectedCreditTypes;
  }

  private async handleSpecialtyChange(
    event: CustomEvent<string>
  ): Promise<void> {
    if (event.cancelable) {
      event.preventDefault();
      event.stopPropagation();
    }

    this._specialtyId = event.detail;
    const context = this._pageContext;
    const service = context ? context.topicListService : null;

    if (service === null) {
      throw new Error("No topic service available.");
    }

    let topicsAndCreditTypes = await service.getTopicsAndCreditTypesBySpecialty(this._specialtyId);

    const topics = topicsAndCreditTypes.topics;
    const creditTypes = topicsAndCreditTypes.creditTypes;

    let cookieValue = this.getCookie("healio.topicfilter" + this._specialtyId);
    let selectedTopics: ITopic[] = [];
    if (cookieValue){
      selectedTopics = JSON.parse(decodeURIComponent(cookieValue)) as ITopic[];
    }

    cookieValue = this.getCookie("healio.credittypefilter" + this._specialtyId);
    let selectedCreditTypes: ICreditType[] = [];
    if (cookieValue){
      selectedCreditTypes = JSON.parse(decodeURIComponent(cookieValue)) as ICreditType[];
    }

    if (topics.length > 0){
      this._element.hidden = false;
    }

    if (this.creditTypes.length > 0){
      this._element.hidden = false;
    }

    this.updateTopics(topics, selectedTopics, creditTypes, selectedCreditTypes);
  }

  private raiseChangeEvent(specialtyChangeEvent?: CustomEvent<string>): void {
    // The "Topic Change" event fires when the filter has detected a change in
    // internal state, such as due to the user clicking on chips or hitting
    // the apply button.  However, it can also fire if a specialty change
    // event is being chained in, even if this event does not result in a
    // change in internal state.  This is because items listening for this
    // event are generally concerned about the combined state of the two
    // filters, and if the specialty filter has changed, then the context of
    // the topic filter has changed, even if the internal state has not.
    // In other words, there is a contextual change between
    // "specialty 1, no topics selected" and "specialty 2, no topics selected",
    // and we need to signal that context shift, even though nothing internal
    // has actually changed.

    const newValue = {
      topics: this._selectedTopics,
      creditTypes : this._selectedCreditTypes
    };
    const creditIds = this._selectedCreditTypes.map(c => c.creditTypeId);
    const topicIds = this._selectedTopics.map(t => t.topicId);
    const ids = creditIds.concat(topicIds);

    if (!specialtyChangeEvent) {
      const sameAsLastTime =
        ids.length != 0 &&
        this._lastSelectedValue.length != 0 &&
        ids.length === this._lastSelectedValue.length &&
        ids.every(id => this._lastSelectedValue.indexOf(id) !== -1);

      if (sameAsLastTime) {
        return;
      }
    }

    this._lastSelectedValue = ids;

    this._element.dispatchEvent(EventUtil.createCustomEvent(TopicAndCreditTypeFilter.TopicFilterChangeEvent, newValue));
  }

  private showHideClearFilter(): void {
    if (this._clearTopicsButton) {
      this._clearTopicsButton.hidden = this._selectedTopics.length > 0 || this._selectedCreditTypes.length > 0
        ? false
        : true;
    }
  }

  public handleMenuApply(ev: Event | null): void {

    if(!this._topicMenuContainer){
      return;
    }

    if(!this._creditTypeMenuContainer){
      return;
    }

    this._selectedTopics = [];
    this._topicMenuContainer.querySelectorAll<HTMLInputElement>("input[type='checkbox']:checked").forEach(topic => {
      if(topic.dataset.topicName && topic.dataset.topicId){
        this._selectedTopics.push({topicId: topic.dataset.topicId, topicName: topic.dataset.topicName});
      }
    });

    this._selectedCreditTypes = [];
    this._creditTypeMenuContainer.querySelectorAll<HTMLInputElement>("input[type='checkbox']:checked").forEach(creditType => {
      if(creditType.dataset.creditTypeName && creditType.dataset.creditTypeId){
        this._selectedCreditTypes.push({creditTypeId: creditType.dataset.creditTypeId, creditTypeName: creditType.dataset.creditTypeName});
      }
    });

    this.setCookie();

    this.updateChips();

    this.showHideClearFilter();

    this.raiseChangeEvent();
  }

  private handleClearAllTopics(ev: Event | null) : void {
    if (ev?.cancelable) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    this._selectedTopics = [];

    this._selectedCreditTypes = [];

    this.setCookie();

    this.updateChips();

    this.clearCheckboxes();

    this.showHideClearFilter();

    this.raiseChangeEvent();
  }

  private updateChips(): void {
    if(this._topicChipsTemplate && this._chipsContainer && this._creditTypeChipsTemplate){

      this._chipsContainer.innerHTML = "";

      for(var topic of this._selectedTopics){
        let html = this._topicChipsTemplate.innerHTML
          .replace("{{topicId}}", topic.topicId)
          .replace("{{topicName}}", topic.topicName)
          .replace("{{topicLabel}}", topic.topicName);
        this._chipsContainer.innerHTML += html;
      }

      for(var creditType of this._selectedCreditTypes){
        let html = this._creditTypeChipsTemplate.innerHTML
          .replace("{{creditTypeId}}", creditType.creditTypeId)
          .replace("{{creditTypeName}}", creditType.creditTypeName)
          .replace("{{creditTypeLabel}}", creditType.creditTypeName);
        this._chipsContainer.innerHTML += html;
      }



      this._chipsContainer.querySelectorAll<HTMLButtonElement>(".topic-chip").forEach(chip => {
        chip.addEventListener("click", e => this.removeTopicChip(chip.dataset.topicId ?? ""));
      });

      this._chipsContainer.querySelectorAll<HTMLButtonElement>(".credit-type-chip").forEach(chip => {
        chip.addEventListener("click", e => this.removeCreditTypeChip(chip.dataset.creditTypeId ?? ""));
      });
    }
  }

  private clearCheckboxes(): void {
    this._topicMenuContainer?.querySelectorAll('input[data-topic-id]').forEach(el => {
      (el as HTMLInputElement).checked = false;
      el.parentElement?.classList.remove("checked");
    });

    this._creditTypeMenuContainer?.querySelectorAll('input[data-credit-type-id]').forEach(el => {
      (el as HTMLInputElement).checked = false;
      el.parentElement?.classList.remove("checked");
    });
  }

  private removeTopicChip(topicId: string): void {
    if(!this._topicMenuContainer){
      return;
    }

    let chipMenuItem = this._topicMenuContainer.querySelector("input[data-topic-id='" + topicId + "']") as HTMLInputElement;
    if(chipMenuItem){
      chipMenuItem.checked = false;
      chipMenuItem.parentElement?.classList.remove("checked");

      this.handleMenuApply(null);
    }
  }

  private removeCreditTypeChip(creditTypeId: string): void {
    if(!this._creditTypeMenuContainer){
      return;
    }

    let chipMenuItem = this._creditTypeMenuContainer.querySelector("input[data-credit-type-id='" + creditTypeId + "']") as HTMLInputElement;
    if(chipMenuItem){
      chipMenuItem.checked = false;
      chipMenuItem.parentElement?.classList.remove("checked");

      this.handleMenuApply(null);
    }
  }


  private updateTopics(topics: ITopic[], selectedTopics: ITopic[], creditTypes: ICreditType[], selectedCreditTypes: ICreditType[]){
    let selectedTopicIds = selectedTopics.map(t => t.topicId);
    if(this._topicMenuContainer && this._topicMenuTemplate){
      for (var topic of topics){
        let html = this._topicMenuTemplate.innerHTML
          .replace("{{topicId}}", topic.topicId)
          .replace("{{topicName}}", topic.topicName)
          .replace("{{topicLabel}}", topic.topicName);
        html.replace("{{checked}}", selectedTopicIds.includes(topic.topicId) ? "checked" : "");

        this._topicMenuContainer.innerHTML += html;
      }
    }

    let selectedCreditTypesIds = selectedCreditTypes.map(ct => ct.creditTypeId);
    if(this._creditTypeMenuContainer && this._creditTypeMenuTemplate){
      for (var creditType of creditTypes){
        let html = this._creditTypeMenuTemplate.innerHTML
          .replace("{{creditTypeId}}", creditType.creditTypeId)
          .replace("{{creditTypeName}}", creditType.creditTypeName)
          .replace("{{creditTypeLabel}}", creditType.creditTypeName);
        html.replace("{{checked}}", selectedCreditTypesIds.includes(creditType.creditTypeId) ? "checked" : "");

        this._creditTypeMenuContainer.innerHTML += html;
      }
    }

    $('input[data-credit-type-id="{93E5D784-C936-42CE-ADA0-B7D30DB3E3A9}"]')[0]?.parentElement?.classList.add("cme")

    $(this._element).find('input.form-check-input').on('change', function(){
      if($(this).is(":checked")) {
        $(this).parent().addClass('checked');
      } else {
        $(this).parent().removeClass('checked');
      }
    });

    this.handleMenuApply(null);
  }

  private setCookie() : void {
    if (window.location.pathname){
      let filterValue = JSON.stringify(this._selectedTopics);
      document.cookie = "healio.topicfilter." + this._specialtyId + "=" + encodeURIComponent(filterValue);

      filterValue = JSON.stringify(this._selectedCreditTypes);
      document.cookie = "healio.credittypefilter." + this._specialtyId + "=" + encodeURIComponent(filterValue);
    }
  }

  private getCookie(cname: string): string {
    const name = cname + "=";
    const ca = document.cookie.split(";");

    for(let c of ca) {
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  }
}

ComponentFactory.registerComponent("TopicAndCreditTypeFilter", TopicAndCreditTypeFilter);
